export default __webpack_public_path__ + "static/media/Squat.4849314b.png";